import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Button from '../../../../../../App/Components/Button/Button'
import TextInput from '../../../../../../App/Components/Form/TextInput/TextInput'
import style from '../../style.scss'
import { ActivitySelect } from '../ActivitySelect/ActivitySelect'

import { TimeSummary } from './component/TimeSummary/TimeSummary'
import { IProps } from './IProps'

export const WaitingItemDetails: FunctionComponent<IProps> = ({
  customer,
  setCustomer,
  date,
  setDate,
  activityList,
  menuList,
  activitySelectObject,
  setActivitySelectObject,
  setHasDate,
  remark,
  setRemark,
  save,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={style.customer} onClick={() => setCustomer(undefined)}>
        <FontAwesomeIcon icon={faTrashAlt} className={style.deleteIcon} />
        {customer.fullName}
      </div>
      <TimeSummary date={date} setHasDate={setHasDate} setDate={setDate} />
      <ActivitySelect
        activitySelectObject={activitySelectObject}
        setActivitySelectObject={setActivitySelectObject}
        activityList={activityList}
        menuList={menuList}
      />
      <TextInput
        label={t('Write a remark or leave blank')}
        value={remark}
        onChange={event => setRemark(event.target.value)}
      />

      <Button type={'button'} onClick={save}>
        {t('Save')}
      </Button>
    </>
  )
}
